import { LinearProgress, Stack, Typography } from "@mui/material";

export type WizardStepProgressProps = {
  totalSteps: number;
  activeStep: number;
};

export function WizardStepProgress({
  totalSteps,
  activeStep,
}: WizardStepProgressProps) {
  const progress = ((activeStep + 1) / totalSteps) * 100;

  if (totalSteps <= 0) return null;

  return (
    <Stack gap={1.5}>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{ height: 6, borderRadius: 4 }}
      />
      <Typography variant="caption" color="text.secondary">
        Step {activeStep + 1} of {totalSteps}
      </Typography>
    </Stack>
  );
}
